// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"f17abd44","453":"1a78e785","484":"d2a2bee5","551":"6ec86440","828":"72738be4"}[chunkId] + ".chunk.js";
};